import { SortOrder } from './types';
import SortOrderIcon from '@/assets/icons/sort-order.svg?react';
import SortDefaultIcon from '@/assets/icons/sort-default.svg?react';
interface HeadSortIconProps {
  sortOrder?: SortOrder;
  onSortChange?: (sortOrder: SortOrder) => void;
  className?: string;
}

export const getNextSortOrder = (currentSortOrder?: SortOrder): SortOrder => {
  switch (currentSortOrder) {
    case 'asc':
      return 'desc';
    case 'desc':
      return 'asc';
    default:
      return 'asc';
  }
};

export const HeadSortIcon = ({ sortOrder, onSortChange }: HeadSortIconProps) => {
  const handleClick = () => {
    const nextSortOrder = getNextSortOrder(sortOrder);
    onSortChange?.(nextSortOrder);
  };

  const renderIcon = () => {
    switch (sortOrder) {
      case 'asc':
        return <SortOrderIcon className=" rotate-180" />;
      case 'desc':
        return <SortOrderIcon />;
      default:
        return <SortDefaultIcon />;
    }
  };

  return (
    <span
      className="  inline-block"
      onClick={handleClick}
      aria-label={`Sort ${sortOrder === 'asc' ? 'ascending' : sortOrder === 'desc' ? 'descending' : 'none'}`}
    >
      {renderIcon()}
    </span>
  );
};
